var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('van-tabs',{on:{"click":_vm.check_tab}},[_c('van-tab',{attrs:{"title":"待核销","name":"writeOff"}}),_vm._v(" "),_c('van-tab',{attrs:{"title":"已核销","name":"writeOn"}}),_vm._v(" "),_c('van-tab',{attrs:{"title":"已失效","name":"lostt"}})],1),_vm._v(" "),_c(_vm.active,{tag:"div",staticClass:"body"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cce49c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gift/index.vue
// module id = null
// module chunks = 